import * as THREE from 'three'
import Experience from '../Experience.js'
import threeTheme from '../Utils/theme.js';

export default class Table {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.createTable();
    }

    static SURFACE_NORMAL_MAP = '/textures/dirt/normal.jpg';
    static SURFACE_REPEAT = 6;
    static SURFACE_NORMAL_SCALE = 0.35;

    createTable() {
        const geometry = new THREE.PlaneGeometry(15, 10);
        const material = new THREE.MeshStandardMaterial();
        material.color = threeTheme.table;
        material.roughness = 0.92;
        material.metalness = 0.0;
        this.mesh = new THREE.Mesh(geometry, material)
        this.mesh.receiveShadow = true
        this.mesh.position.z = -0.035
        this.scene.add(this.mesh)

        this.loadSurfaceGrain(material);
    }

    loadSurfaceGrain(material) {
        new THREE.TextureLoader().load(Table.SURFACE_NORMAL_MAP, (texture) => {
            texture.wrapS = THREE.RepeatWrapping;
            texture.wrapT = THREE.RepeatWrapping;
            texture.repeat.set(Table.SURFACE_REPEAT, Table.SURFACE_REPEAT);
            this.grainTexture = texture;

            material.normalMap = texture;
            material.normalScale.set(Table.SURFACE_NORMAL_SCALE, Table.SURFACE_NORMAL_SCALE);
            material.needsUpdate = true;
        });
    }

    getMesh() {
        return this.mesh;
    }

    destroy() {
        if (!this.mesh) return;

        this.mesh.geometry.dispose();
        this.mesh.material.dispose();
        this.grainTexture?.dispose();
        this.grainTexture = null;
        this.scene.remove(this.mesh);
        this.mesh = null;
    }
}
